import 'isomorphic-unfetch';
import { parse } from 'query-string';
let trackEmailId;

const serialize = (obj: any) => {
  const str = [];
  for (const p in obj) {
    if (obj.hasOwnProperty(p) && obj[p] != null) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }
  return str.join('&');
};

function abTestTracker() {
  const abTest = JSON.parse(sessionStorage.getItem('abTest'));
  if (abTest && abTest['mfpages']) {
    return 'mfpages-true';
  } else {
    return 'mfpages-false';
  }
}

export function loggedUserEmail(emailID: string) {
  trackEmailId = emailID;
}

export function handleTrack(logObj: any) {
  const { action = 'Click', category = 'save', obj } = logObj;
  let { label = '', value = '', url = '' } = logObj;
  if (obj) {
    label += `_${obj.textContent}`;
    url = url || obj.href;
  }
  value = `{}redirect_url :: ${url}${value}{}email :: ${trackEmailId}`;
  trackAction(action, category, label, value);
}

// action - [Verb] The type of interaction (e.g. 'play')
// category - Typically the object that was interacted with (e.g. 'Video')
// label - Useful for categorizing events (e.g. 'Fall Campaign')
// value - A numeric value associated with the event (e.g. 42)
export function trackAction(
  action: string,
  category: string,
  label?: string,
  value?: string,
  disableGA: boolean = false
) {
  try {
    if (!disableGA) {
      if (typeof window !== 'undefined' && window.ga) {
        window.ga('send', 'event', category, action, label, value);
      }
    }
    const qs = serialize({
      action,
      category,
      label,
      value,
      original_ref: document.referrer,
      platform: JSON.stringify({ ab_test: abTestTracker() }),
    });
    if (typeof Image !== 'undefined') {
      const img = new Image();
      img.src = '/funnelmetrics/clearsave/eventModel' + '?' + qs;
    }
  } catch (err) {
    throw err;
  }
}

export const trackActionXHR = (
  host: string,
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  const qs = serialize({
    action,
    category,
    label,
    value,
    platform: JSON.stringify({ ab_test: abTestTracker() }),
  });
  // No requirement for the then and catch handler.
  return fetch(`${host}/funnelmetrics/clearsave/eventModel?${qs}`);
};

export function trackPage(pageName: string) {
  try {
    if (typeof window !== 'undefined' && window.ga) {
      window.ga('set', 'page', pageName);
      window.ga('send', 'pageview');
    }
    const qs = serialize({
      location: location.href,
      hostname: JSON.stringify({
        hostname: location.hostname,
        ab_test: abTestTracker(),
      }),
      page: location.pathname,
      title: document.title,
      original_ref: document.referrer,
      ref: parse(location.search).ref || '',
    });
    if (typeof Image !== 'undefined') {
      const img = new Image();
      img.src = '/funnelmetrics/clearsave/pageView' + '?' + qs;
    }
  } catch (err) {
    throw err;
  }
}

export function trackPixel(eventName: string, customData: any = {}) {
  try {
    customData.query_slug = location.search;
    customData.content_ids = 'Save';
    if (fbq) {
      fbq('track', eventName, customData);
    }
    if (qp) {
      qp('track', eventName);
    }
  } catch (err) {}
}

export interface EcomTransaction {
  id: string;
  affiliation?: string;
  revenue?: number;
  shipping?: number;
  tax?: number;
}

export interface EcomItem {
  id: string;
  name: string;
  sku?: string;
  category?: string;
  price?: number;
  quantity?: number;
}

export function trackEcom(transaction: EcomTransaction, items: EcomItem[]) {
  if (typeof window !== 'undefined' && window.ga) {
    window.ga('ecommerce:addTransaction', transaction);
    items.forEach(item => window.ga('ecommerce:addItem', item));
    window.ga('ecommerce:send');
  }
}



// WEBPACK FOOTER //
// ./utils/trackActions.ts